import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import PricingPage from '../PricingPage/PricingPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import PortfolioSinglePage from '../PortfolioSinglePage/PortfolioSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';
import HelpCenter from '../HelpCenter/HelpCenter';
import PrivacyPage from '../General/privacy-policy';
import TermsPage from '../General/terms-conditions';
import RefundPage from '../General/refund';
import CheckoutPage from '../General/checkout';
import Success from '../General/success';
import RenewPage from '../General/renew';
import UpgradePlan from '../PricingPage/UpgradePlan';
import UpgradePay from '../General/upgrade-pay';
import Thankyou from '../General/thankyou';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="helpcenter" element={<HelpCenter />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio_details/:slug" element={<PortfolioSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />  
          <Route path="privacy-policy" element={<PrivacyPage />} />  
          <Route path="terms-conditions" element={<TermsPage />} /> 
          <Route path="refund" element={<RefundPage />} />  
          <Route path="checkout" element={<CheckoutPage />} />  
          <Route path="renew/:appid" element={<RenewPage />} />
          <Route path="upgrade/:appid" element={<UpgradePlan />} />
          <Route path="upgrade/checkout/:appid" element={<UpgradePay />} />
          <Route path="success" element={<Success />} />  
          <Route path="thankyou" element={<Thankyou />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
